import { FC } from 'react'
import DSTitle from 'libs/shared/ui/src/lib/components/generics/ds-title'
import BodyText from 'libs/shared/ui/src/lib/components/generics/body-text'

interface MessagesModalGenericProps {
  onClose: () => void
  description: string | React.ReactNode
  title: string
  button?: string
  icon?: string | React.ReactNode
  children?: React.ReactNode
  className?: string
  className2?: string
}

export const MessagesModalGeneric: FC<MessagesModalGenericProps> = ({
  onClose,
  description,
  title,
  button,
  icon,
  children,
  className,
  className2,
}) => {
  return (
    <div
      className={`fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 font-aeonik ${className}`}
    >
      <div
        className={`bg-white px-6 py-12 rounded-lg shadow-lg relative w-[358px] md:w-[768px] max-h-[90vh] overflow-y-auto ${className2}`}
      >
        <div className="flex flex-col justify-between h-full text-[20px]">
          <div>
            <DSTitle className="text-[20px] font-bold">{title}</DSTitle>
            <div className="flex justify-center items-center mt-3 mb-7">
              {icon}
            </div>
            <BodyText className="text-[16px] md:text-[20px]">
              {description}
            </BodyText>
          </div>
          {children}
          {button && (
            <button
              onClick={onClose}
              className="bg-generic-primary-50 text-generic-neutral-900 p-2 rounded-md w-full h-10 border border-primary mt-4"
            >
              <BodyText className="text-center text-generic-neutral-900 font-aeonik">
                {button}
              </BodyText>
            </button>
          )}
        </div>
      </div>
    </div>
  )
}
